module.exports = __webpack_public_path__ + "static/media/weixin.6e238035.svg";